import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Llegás a tu casa y en lugar de descansar, algo te pesa', 'El ambiente está raro. Hay tensión sin motivo aparente', 'Dormís mal. Te despertás cansada sin razón', 'Las plantas mueren. Las mascotas se comportan raro', 'Los conflictos se repiten siempre en el mismo rincón', 'Prendiste sahumerios y pusiste sal gruesa pero nada cambió de verdad'];
  return <Section className="max-w-4xl" data-id="element-261">
      <div className="text-center mb-12" data-id="element-262">
        <h2 className="md:text-5xl font-serif font-bold mb-6 text-[28px]" data-id="element-263">
          ¿Te suena esto?
        </h2>
        <p className="text-brand-text/90 mb-4 text-[14px]" data-id="element-264">
          Llegás a tu casa y en lugar de descansar, algo te pesa. El ambiente
          está raro. Hay tensión sin motivo.
        </p>
        <p className="text-brand-text/90 mb-4 text-[14px]" data-id="element-265">
          Prendiste algún sahumerio. Duró 48 horas. Probaste con sal gruesa.
          Nada cambió de verdad. Porque no es falta de intención. Es falta de un
          sistema.
        </p>
        <p className="text-xl font-medium mt-6 text-[#6A4808]" data-id="element-266">
          No es tu imaginación. Es energía acumulada. Y tiene solución.
        </p>
      </div>

      <div className="glass-panel p-8 md:p-10 rounded-3xl mb-12 space-y-[14px]" data-id="element-267">
        <h3 className="text-2xl md:text-3xl font-serif font-bold mb-8 flex items-center text-brand-text" data-id="element-268">
          <X className="w-7 h-7 text-red-500 mr-3" data-id="element-269" /> Esto te resulta familiar:
        </h3>
        <ul className="space-y-5" data-id="element-270">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-271">
              <X className="w-5 h-5 text-red-500/70 mr-3 mt-1 shrink-0" data-id="element-272" />
              <span className="text-brand-text text-[17px] md:text-lg leading-relaxed" data-id="element-273">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-274">
        <h3 className="text-2xl md:text-3xl font-serif font-bold gold-gradient-text" data-id="element-275">
          ¿Y si la próxima noche fuera completamente diferente?
        </h3>
      </div>
    </Section>;
};